import { Checkbox, FormControlLabel, FormGroup } from "@mui/material"
import React, { useState } from "react"
import { Card, Form, InputGroup } from "react-bootstrap"
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export default function BoxSelector({ title, allItems, itemsAssigned, setItemsAssigned, availableItems }) {
	const [inputValue, setInputValue] = useState("")
	const [showAll, setShowAll] = useState(false)

	// Separa los asignados en: los que están en el lab y los que no
	const itemsInLab = itemsAssigned.filter(item =>
		availableItems?.some(a => a._id === item._id)
	)
	const itemsOutOfLab = availableItems
		? itemsAssigned.filter(item => !availableItems.some(a => a._id === item._id))
		: []

	return (
		<Card
			className="input--primary mb-3"
			style={{ width: "100%" }}
		>
			<Card.Body>
				<Card.Text>{title}</Card.Text>
				<div
					style={{
						display: "flex",
						alignItems: "baseline",
						justifyContent: "center",
						gap: ".3rem",
					}}
				>
					<p>Ver todo</p>
					<Form.Check
						type="switch"
						id="extra-order-switch"
						checked={showAll}
						onChange={() => setShowAll(prev => !prev)}
					></Form.Check>
				</div>
				<Form.Control
					className="input-primary"
					type="text"
					style={{
						marginBottom: ".5rem",
					}}
					value={inputValue}
					onChange={e => setInputValue(e.target.value)}
				/>
				<div
					style={{
						maxHeight: "400px",
						overflowY: "auto",
					}}
				>
					{allItems.map(item => {
						// Filtro del buscador
						if (!showAll && inputValue === "") return
						if (!showAll && !item.name.toUpperCase().includes(inputValue.toUpperCase())) return

						// Filtro de items ya agregados
						if (itemsAssigned && itemsAssigned.some(itemAssigned => itemAssigned.name === item.name)) return

						return (
							<FormGroup key={item.name}>
								<FormControlLabel
									control={<Checkbox onChange={() => setItemsAssigned([...itemsAssigned, item])} />}
									label={item.name}
								/>
							</FormGroup>
						)
					})}
				</div>

				{itemsAssigned.length > 0 && (
					<>
						<hr />

						{/* Si no hay availableItems, comportamiento original */}
						{!availableItems && itemsAssigned.map(item => (
							<FormGroup key={item.name}>
								<FormControlLabel
									control={
										<Checkbox
											onChange={() => setItemsAssigned(itemsAssigned.filter(prevItem => prevItem._id !== item._id))}
											checked={true}
										/>
									}
									label={item.name}
								/>
							</FormGroup>
						))}

						{/* Si hay availableItems, mostrar separado */}
						{availableItems && (
							<>
								{itemsInLab.length > 0 && (
									<>
										<p style={{ fontWeight: "normal", marginBottom: "4px" }}>
											Habilitados en laboratorio seleccionado
										</p>
										{itemsInLab.map(item => (
											<FormGroup key={item.name}>
												<FormControlLabel
													control={
														<Checkbox
															onChange={() => setItemsAssigned(itemsAssigned.filter(p => p._id !== item._id))}
															checked={true}
														/>
													}
													label={item.name}
												/>
											</FormGroup>
										))}
									</>
								)}

								{itemsOutOfLab.length > 0 && (
									<>
										<hr />
										<p style={{ fontWeight: "normal", marginBottom: "4px", display: "flex", alignItems: "center", gap: "4px" }}>
											<ErrorOutlineIcon fontSize="small" style={{ color: "#f5732cff" }} />
											Habilitados solo al usuario
										</p>
										<p style={{ fontSize: "0.8rem", color: "#888", marginBottom: "8px" }}>
											Estos productos no están asignados a ningún laboratorio seleccionado. Necesita asignarlos a un laboratorio o destildar para eliminar.
										</p>
										{itemsOutOfLab.map(item => (
											<FormGroup key={item.name}>
												<FormControlLabel
													control={
														<Checkbox
															onChange={() => setItemsAssigned(itemsAssigned.filter(p => p._id !== item._id))}
															checked={true}
														/>
													}
													label={item.name}
												/>
											</FormGroup>
										))}
									</>
								)}
							</>
						)}
					</>
				)}
			</Card.Body>
		</Card>
	)
}
